import { CSSProperties } from 'react';

import { bodyWidth } from 'constants/values';

export const container: CSSProperties = {
  backgroundColor: '#fff',
  width: '100%',
};

export const body: CSSProperties = {
  height: 456,
  margin: 'auto',
  position: 'relative',
  width: bodyWidth,
};

export const image1: CSSProperties = {
  height: 318,
  left: 532,
  position: 'absolute',
  top: 60,
  width: 376,
};

export const image2: CSSProperties = {
  height: 54,
  left: 480,
  position: 'absolute',
  top: 302,
  width: 38,
};

export const image3: CSSProperties = {
  height: 55,
  left: 915,
  position: 'absolute',
  top: 300,
  width: 44,
};
